import { UseQueryOptions } from '@tanstack/react-query';
import { WhitelistIpConfig, GetAllByUserIDPath, urlCombine } from 'ihub/common';
import { CRUDHelperBase } from '../classes/crud-helper-base';
import {
	coreAPI,
	getTenantID,
	isURLSet,
	standardGet,
	validateOkResponse,
} from '../classes/http-helper-const';
import Parameter from '../classes/query-parameter';
import { cacheStaleTime } from '../constants';
import QueryClientWrapper from '../utils/create-query-client';

export class WhitelistIpHttpService extends CRUDHelperBase<WhitelistIpConfig> {
	constructor() {
		super(WhitelistIpConfig.name);
	}

	getAllByUserID(
		queryParams?: Parameter[]
	): UseQueryOptions<WhitelistIpConfig[], Error, WhitelistIpConfig[]> {
		return {
			queryKey: [
				getTenantID(),
				this.objectType,
				GetAllByUserIDPath,
				queryParams?.map(x => `${x.key}=${x.value}`).join('&'),
			],
			queryFn: async (): Promise<WhitelistIpConfig[]> => {
				isURLSet();
				let url = urlCombine(coreAPI, this.objectType, GetAllByUserIDPath);
				if (queryParams && queryParams.length > 0) {
					url += `?` + queryParams.map(x => `${x.key}=${x.value}`).join('&');
				}
				const res = await standardGet(url);
				validateOkResponse(res, 'get all by ID', this.objectType);
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}

	async invalidateGetAllByUserID() {
		await QueryClientWrapper.InvalidateKey(
			[getTenantID(), this.objectType, GetAllByUserIDPath],
			false
		);
	}
}
